module.exports = __webpack_public_path__ + "img/header-weddingRingsCertificate.444dade.jpg";